import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
// import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoIcon from "@mui/icons-material/Info";
import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  Tooltip,
  InputAdornment,
  TextField,

} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import { useFormik } from "formik";
import * as yup from "yup";
// import UserTpsss from "../../../../assets/images/usertps.png";
import UserTpsss from "../../../../assets/images/u tps.svg";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
export default function UserTps() {
  const [open, setOpen] = useState();
  const [maxLimit, setMaxLimit] = useState();
  const [error, seterror] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [fetchData, setFetchData] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [paginationPage, setPaginationPage] = React.useState(1);

  const [Status, setStatus] = useState({
    approveType: 0,
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const initialValues = {
    tpsLimit: "1",
  };
  const validationSchema = yup.object({
    tpsLimit: yup
      .string()
      //  .min(8, "Minimum length of a mobile number is 8 digits")
      //  .max(8, "Maximum length of mobile number is 8 digits")
      .required("Required"),
  });
  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // seterror(false);
       EditAction(values);
    },
  });

  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  // console.log("km",open,data)
  const modelButtonApprove = useRef(null);
  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
  await formik.setFieldValue("tpsLimit",cell.row.original.tpsLimit)
    await modelButtonApprove.current.click();
  };
  const customId1 = "custom-id-yes";




  async function EditAction(values) {
    // setOpen(true);
    try {
        setHideSkeleton(true);
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/update/tps`,
          {
            id: selectedUserDetailApprove.id,
            username: selectedUserDetailApprove.username,
            tpsLimit: values.tpsLimit,
            userId: selectedUserDetailApprove.userId,
            createdUsername: localStorage.getItem("usernamedisplayed"),
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          // setOpen(false);
          setHideSkeleton(false);
          BulkTableget();
        } else {
          setHideSkeleton(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }

      
     
    } 
    
    
    catch (error) {
      // setOpen(false);
      setHideSkeleton(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    // CreditPost();
  }, []);
  // ...................................................................................................//

  async function BulkTableget() {
    setData([]);
    setOpen(true);

    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/tps`,

        // "http://192.168.167.66:5002/v1/get-all/file",
        {
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        await setData(result.data.tpsControl.content);
        await setData1(result.data.tpsControl);
        setOpen(false);

        // document.getElementById("fileName").value = "";
      } else {
        // setTableLoader(false);
        setOpen(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // console.log(result.data.statusMessage);
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // ...................................................................................................//

  async function RefreshBtn() {
    setData([]);
    setOpen(true);

    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/tps`,

        // "http://192.168.167.66:5002/v1/get-all/file",
        {
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        await setData(result.data.tpsControl.content);
        await setData1(result.data.tpsControl);
        setOpen(false);

        // document.getElementById("fileName").value = "";
      } else {
        // setTableLoader(false);
        setOpen(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // console.log(result.data.statusMessage);
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",

        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(async () => {
    BulkTableget();
  }, [Status.pageSize, Status.pageNo]);
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
        ? [
            {
              Header: "Id",
              Footer: "ID",
              accessor: "id",
              Cell: (cell) => (
                <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
              ),
            },
            {
              Header: "Username",

              accessor: "username",
            },
            {
              Header: "Assigned By",

              accessor: "createdUsername",
            },

            {
              Header: "Tps Limit",

              accessor: "tpsLimit",
            },
            {
              Header: "Assigned Date Time",

              accessor: "datetime", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return (
              //     <>
              //       <div>
              //         {cell?.row?.original?.rechargeDate
              //           ?.split(" ")
              //           ?.map((dataaa) => {
              //             return (
              //               <>
              //                 <span>{dataaa}</span>
              //                 <br />
              //               </>
              //             );
              //           })}
              //       </div>
              //     </>
              //   );
              // },
            },

            {
              Header: "Action",
              accessor: "action",
              Cell: (cell) => (
                <div className="dropdown">
                  <button
                    className="btn color_1 dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons opacity-10 size">person</i>
                    {/* <DeleteIcon /> */}
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        <EditIcon className="color_Green_UP me-2" />
                        Edit Details
                      </a>
                    </li>
                  </ul>
                </div>
              ),
              disableFilters: true,
            },
          ]
        : [
            {
              Header: "Id",
              Footer: "ID",
              accessor: "id",
              Cell: (cell) => (
                <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
              ),
            },
            {
              Header: "Username",

              accessor: "username",
            },
            {
              Header: "Assigned By",

              accessor: "createdUsername",
            },

            {
              Header: "Tps Limit",

              accessor: "tpsLimit",
            },
            {
              Header: "Assigned Date Time",

              accessor: "datetime", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return (
              //     <>
              //       <div>
              //         {cell?.row?.original?.rechargeDate
              //           ?.split(" ")
              //           ?.map((dataaa) => {
              //             return (
              //               <>
              //                 <span>{dataaa}</span>
              //                 <br />
              //               </>
              //             );
              //           })}
              //       </div>
              //     </>
              //   );
              // },
            },
          ],
    [Status]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  

  const viewRefModal = useRef(null);

  const { globalFilter, pageIndex, pageSize } = state;

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  //   useEffect(()=>{
  // return() =>{
  //   localStorage.removeItem("TpsControlLimit");
  // }
  //   },[])



  //  ..................................TPS Get API..................................................//
async function TpsGet() {
  // setdata([]);
  // setHideSkeleton1(true);
  try {

if(JSON.parse(localStorage.getItem("Sidebaritems")).name ==
"ROLE_SUPER_ADMIN"){
  const result = await common_axios.get(
    `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/system-tps`
  );

  // console.log("result get api.........", result);

  if (result.data.statusDescription.statusCode == 200) {
    setOpen(false);
    await setMaxLimit(result.data.systemTpsModel);
    // await formik.setFieldValue("tpsLimit", result.data.systemTpsModel.tpsLimit);
    // setHideSkeleton1(false);
  } else {
    // setOpen();
    // setHideSkeleton1(false);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: result.data.statusDescription.statusdescription,
    });
  }
}
   
  } catch (error) {
    // setOpen();
    // setHideSkeleton1(false);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please Check Your Network",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
}
useEffect(() => {
  TpsGet();
}, []);

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

        {/* {selectedUserDetailApprove != undefined && ( */}
        <form
                      onSubmit={formik.handleSubmit}
                      className="row g-3 needs-validation"
                      novalidate
                    >
        <div>
          <button
            ref={modelButtonApprove}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div
              className="modal-dialog "
              style={{ width: "31%", maxWidth: "100%" }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    Update Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row" id="row_focus">


                  <div className="col-md-6" id="tool_tip">
                        <TextField
                          required
                          className="w-100"
                          label="TPS Limit"
                          name="tpsLimit"
                          variant="outlined"
                          size="small"
                          type="text"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="TPS Limit"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.tpsLimit}
                          onChange={formik.handleChange}
                          error={
                            (formik.touched.tpsLimit &&
                              Boolean(formik.errors.tpsLimit)) ||
                            Number(formik.values.tpsLimit) >
                              Number(maxLimit?.tpsLimit) ||
                            Number(formik?.values?.tpsLimit) === 0
                          }
                          helperText={
                            (formik.touched.tpsLimit &&
                              formik.errors.tpsLimit) ||
                            (Number(formik.values.tpsLimit) >
                              Number(maxLimit?.tpsLimit) &&
                              `TPS Limit should be less than or equal to
                                ${maxLimit?.tpsLimit}`) ||
                            (Number(formik?.values?.tpsLimit) === 0 &&
                              "TPS Limit should not be 0")
                          }
                          onInput={(e) => {
                            // e.target.value = Math.max(0, parseInt(e.target.value))
                            //   .toString()
                            //   .slice(0, 8);
                            let Num = maxLimit?.tpsLimit?.toString();
                            e.target.value = e.target.value.slice(
                              0,
                              Num?.length
                            );
                          }}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;

                            if (
                              (keyCode >= 48 && keyCode <= 57) ||
                              keyCode == 13
                            ) {
                              // seterror(false);
                              if (
                                Number(formik.values.tpsLimit) >
                                Number(maxLimit?.tpsLimit)
                              ) {
                                seterror(true);
                              } else {
                                seterror(false);
                              }
                            } else {
                              event.preventDefault();
                              seterror(true);
                            }
                          }}
                        />

                        {/* <div className="row">
                          {error == true ? (
                            <>
                              <p style={{ color: "red" }}>
                                Only Numbers Are Allowed!!
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div> */}
                        {/* <div className="mt-2">
                          {Number(formik?.values?.tpsLimit) >
                          Number(maxLimit?.tpsLimit) ? (
                            <>
                              <p style={{ fontSize: "12px", color: "#d32f2f" }}>
                                TPS Limit should be less than or equal to{" "}
                                {`${maxLimit?.tpsLimit}`}
                               
                              </p>
                            </>
                          ) : Number(formik?.values?.tpsLimit) === 0 ? (
                            <>
                              <p style={{ fontSize: "12px", color: "#d32f2f" }}>
                                TPS Limit should not be 0
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div> */}
                        <label
                          className="d-block mb-0 mt-2"
                          style={{ marginTop: "-8px" }}
                        >
                          <span style={{ color: "red" }}>*</span>
                          (TPS Limit should be {`${maxLimit?.tpsLimit}`})
                        </label>
                      </div>


                    {/* <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label ">
                        TPS Limit :
                      </label>
                      <input
                        className="form-control px-2"
                        placeholder=" Tps Limit"
                        type=" text"
                        value={selectedUserDetailApprove?.tpsLimit}
                        onChange={(e) => {
                          setSelectedUserDetailApprove({
                            ...selectedUserDetailApprove,
                            tpsLimit: e.target.value,
                          });
                        }}
                      />
                      <div className="mt-2">
                        {Number(selectedUserDetailApprove?.tpsLimit) >
                          Number(maxLimit?.tpsLimit) && (
                          <>
                            <p style={{ fontSize: "12px", color: "#d32f2f" }}>
                              TPSLimit should be less than or equal to SystemTps
                              Limit
                            </p>
                          </>
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="modal-footer justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary shadow"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
 disabled={
                           
                            Number(formik?.values?.tpsLimit) >
                              Number(maxLimit?.tpsLimit) ||
                            Number(formik?.values?.tpsLimit) === 0
                          }


                    // disabled={
                    //   selectedUserDetailApprove?.tpsLimit === "" ||
                    //   Number(selectedUserDetailApprove?.tpsLimit) >
                    //     Number(maxLimit?.tpsLimit)
                    // }
                    type="submit"
                    className="btn btn-primary editcolor shadow okbtn"
                    // className={`form-control px-2 ${
                    //       error ? "errorInputfield" : ""
                    //     }`}
                    data-bs-dismiss="modal"
                    //   onClick={() => {
                    //     approveUserApi(
                    //       selectedUserDetailApprove
                    //     );
                    //   }}
                    // onClick={EditAction}

                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* )} */}
</form>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              {/* <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />{" "} */}
              <img src={UserTpsss} class="img-fluid d-block m-auto" style={{width:'44px',}}/>
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                User TPS
              </p>
            </div>
          </div>

          <div className="card-body row">
            {data?.length > 0 ? (
              <>
                <>
                  <div className="d-flex justify-content-between mt-4">
                    <select
                      value={Status.pageSize}
                      className="dropdown"
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setStatus({
                          ...Status,
                          pageSize: e.target.value,
                        });
                      }}
                    >
                      {[10, 25, 50].map((value, i) => {
                        return (
                          <option
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                            value={value}
                            key={value}
                          >
                            Show {value}
                          </option>
                        );
                      })}
                    </select>

                    <Tooltip title="Refresh">
                      <button
                        type="submit"
                        className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                        onClick={RefreshBtn}
                        // onClick={() => RefreshBtn("Text to Copy")}
                      >
                        {/* <i class="material-icons opacity-10">refresh</i> */}
                        <RefreshIcon />
                      </button>
                    </Tooltip>

                    {/* <TextField
                        className="ms-4"
                        style={{
                          borderRadius: "4px",
                        }}
                        type="text"
                        label="Search"
                        name="Search"
                        variant="outlined"
                        // value={number}
                        size="small"
                        value={globalSearchValue || ""}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setGlobalSearchValue(e.target.value);
                        }}
                      /> */}
                  </div>
                </>

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody class='onhover_change' {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  // className="text-left"
                                  //   className={
                                  //   (cell.column.Header == "User Id" ||
                                  //     cell.column.Header == "Amount" ||
                                  //     cell.column.Header == "Start Date") &&
                                  //   "text-end"
                                  // }

                                  className={
                                    cell.column.Header == "Id" ||
                                    cell.column.Header == "Tps Limit"
                                      ? "text-end"
                                      : cell.column.Header == "Action"
                                      ? "text-center"
                                      : "text-start"
                                  }
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>

                  <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setStatus({
                          ...Status,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setStatus({
                    ...Status,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setStatus({
                          ...Status,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>

{/* 
                  <div>
                    <button
                      className="btn btn_primary "
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo - 1,
                        });
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary ms-2"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={
                        data1?.totalPages == data1?.pageable?.pageNumber + 1
                      }
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo + 1,
                        });
                      }}
                    >
                      Next
                    </button>
                  </div> */}
                </div>
              </>
            ) : (
              <div className="text-center mt-4">
                {data?.length == 0 && open == true ? null : data?.length == 0 &&
                  open == undefined ? null : (
                  <div className="text-center">
                    <h5>No Record Found..!!</h5>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
